<template>
  <form
    :class="cbvisible == true ? 'needs-validation open w-93'  : 'needs-validation w-93'"
    action="" method="post" novalidate :style="parentID == 'list' ? 'float:right; margin-right:5px;' : ''">
    <div class="form-row">
      <div class="autosuggest-container w-93">
        <!-- <div role="combobox" aria-expanded="false" aria-haspopup="listbox" aria-owns="autosuggest-autosuggest__results" class="input-group input-group-lg">  -->

          <vue-autosuggest ref="autocomplete" v-model="search.keyword" :suggestions="suggestions" :inputProps="inputProps"
            :sectionConfigs="sectionConfigs" :getSuggestionValue="getSuggestionValue" :class="combobox" @focus="focusMe"
            @click="clickHandler" @input="fetchResults" @keyup.enter="testsearch">
            <template slot="after-input">
              <div class="input-group-append-search" v-if="parentID != 'shoppingcart'">
                                   <!-- btn btn-gray-50 w-100 border-0  -->
                <button class="btn btn-white w-100 border_append border-left-0" style="padding: .5rem 1rem;
                                    font-size: 1rem;
                                    line-height: 1.5;
                                    border-top-left-radius: .0rem;
                                    border-bottom-left-radius: .0rem;
                                    border-top-right-radius: 0.5rem;
                                    border-bottom-right-radius: 0.5rem;" @click.prevent="set_contentnav" ref="searchbutton"><span class="sr-only">{{
                                    __('lang.btn.search') }}</span>
                  <svg class="icon m-0">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.search"
                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>
                </button>
              </div>
              <div class="input-group-append-search" v-else>
                <button class="btn btn-gray-50 w-100 border-0" style="padding: .36rem .75rem;" role="button"
                  @click.prevent="storeSelectedProducts()" ref="addtoshoppingcartbutton"><span class="sr-only">{{ __('lang.shoppingcart.add') }}</span>
                  <svg class="icon icon-sm m-0">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.in-cart-alternative"
                      xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>
                </button>
              </div>
            </template>
            <template slot="before-section-products">

              <li class="autosuggest__results-item font-weight-bold">
                  <h6 class="text-center">{{ __('lang.resultlist.header_fans') }}</h6>
                <div class="row">
                  <div class="col-md-2">
                    {{ __('lang.shoppingcart.tablecolheader.refno') }}
                  </div>
                  <div class="col-md">
                    <p>{{ __('lang.global.product.tabs.techdata.desc_short') }}</p>
                  </div>
                </div>
              </li>
            </template>
            <template slot="before-section-accessories">
                  <li class="autosuggest__results-item font-weight-bold">
                      <h6 class="text-center">{{ __('lang.global.product.tabs.accessories') }}</h6>
                      <div class="row">
                          <div class="col-md-2">
                              {{ __('lang.shoppingcart.tablecolheader.refno') }}
                          </div>
                          <div class="col-md">
                              <p>{{ __('lang.global.product.tabs.techdata.desc_short') }}</p>
                          </div>
                      </div>
                  </li>
              </template>

            <!-- /*


            <li class="autosuggest__results-before autosuggest__results-before--accessories">accessories</li>
                <template slot="before-input"> content before the input goes here </template>
                <template slot="after-input"> content after the input goes here </template>
                <template slot="before-suggestions"> content before the ul goes here </template>
                <template slot="before-section-products"> section header content for specific section goes here </template>
                <template slot="after-section-products"> footer content goes here for specific section. </template>
                <template slot="after-section"> Default footer content for all sections </template>
                <template slot="after-suggestions"> content after the ul goes here </template>
              */ -->

            <template slot-scope="{suggestion}">
              <div class="row">
                <div class="col-md-2">
                  {{ suggestion.item.ref_no }}
                </div>
                <div class="col-md">
                  <p class="font-weight-bold">{{ suggestion.item.type }}</p>
                  <p>{{ suggestion.item.description_short }}</p>
                </div>
              </div>
            </template>
          </vue-autosuggest>
       <!--  </div> -->


      </div>
    </div>
    <div v-show="parentID == 'main'" class="form-row position-absolute w-100 text-left" id="archive-wrapper">
      <div class="form-group w-0 px-2 py-1">
        <div class="custom-control custom-checkbox">


          <input type="checkbox" class="custom-control-input" id="archive" name="archive" v-model="search.archive">
          <label class="custom-control-label labelprevent" for="archive" @click="preventDefault">
            <span class="small">{{ __('lang.heliosselect.jumbotron.search.archive') }}</span>
          </label>


        </div>
      </div>
    </div>
    <div v-show="parentID != 'main' && parentID != 'shoppingcart'" class="form-row position-absolute w-100 text-left" id="archive-wrapper">
      <div class="form-group w-0 px-2 py-1">
        <div class="custom-control custom-checkbox">


          <input type="checkbox" class="custom-control-input" id="archive" name="archive" v-model="search.archive">
          <label class="custom-control-label" for="archive"><span class="small">{{ __('lang.heliosselect.jumbotron.search.archive') }}</span>
          </label>


        </div>
      </div>
    </div>





  </form>
</template>

<script>
//import {EventBus}  from  './services/eventbus/event-bus'
import operatingpointApi from './services/api/operatingpointAPI.js'
import productdataApi from './services/api/productdataAPI.js'
import { VueAutosuggest } from 'vue-autosuggest';
export default {
  components: {
    VueAutosuggest
  },
  computed: {
    search: {
      get() {
        return this.$store.state.operatingpoint.search
      },
      set(value) {
        this.$store.commit('operatingpoint/updatesearch', value);
      }
    },
    user_settings: {
      get() {
        return this.$store.state.operatingpoint.user_settings
      }
    },
    user: {
          get() {
              return this.$store.state.user.user
          },
          set(value) {
              this.$store.commit('user/updateUser', value)
          }
      },
      selectedlocale: {
          get() {
              return this.$store.state.user.selectedlocale
          },
          set(value) {
              this.$store.commit('user/updateSelectedlocale', value)
          }
      },

  },
  props: ['parentID'], //from mainpagejumbotron ='main', from productlistjumbotron ='list'
  data() {
    return {
      from: '',
      cbvisible: true,
      results: [],
      timeout: null,
      selected: null,
      debounceMilliseconds: 250,
      inputProps: {
        id: "autosuggest__input",
        placeholder: this.parentID != 'shoppingcart' ? this.__('lang.heliosselect.jumbotron.search.placeholder') : this.__('lang.shoppingcart.addproductplaceholder'),
        class: "autosuggest__input form-control rounded-left bg-white -border-0",
        name: "keyword",
        type: "search",
        style: this.parentID != 'shoppingcart' ? 'font-size: 1.25rem':''
      },

      combobox: 'input-group w-100',

      suggestions: [],
      sectionConfigs: {
        default: {
          limit: 20,
        },
        products: {
          limit: 0,
          label: "fans",
          onSelected: selected => {
            this.selected = selected.item;
            this.search.keyword = selected.item.ref_no + ' ' + selected.item.type
            this.$refs.autocomplete.$el.querySelector("input").focus();
          },
          onInputChange: inputvalue => {

            this.search.keyword = selected.item.ref_no + ' ' + selected.item.type
          }
        },
          accessories: {
              limit: 0,
              label: "accessories",
              onSelected: selected => {
                  this.selected = selected.item;
                  this.search.keyword = selected.item.ref_no + ' ' + selected.item.type
                  this.$refs.autocomplete.$el.querySelector("input").focus();
              },
              onInputChange: inputvalue => {

                  this.search.keyword = selected.item.ref_no + ' ' + selected.item.type
              }
          }
      },
      mediaserver_url: '',//'https://globalstest.heliosventilatoren.de' ,

    }
  },
  methods: {
    testsearch() {
      if (this.parentID != 'shoppingcart')   this.$refs.searchbutton.click();  //this.set_contentnav()
      else  this.$refs.addtoshoppingcartbutton.click(); // storeSelectedProducts()
    },
    preventDefault(e) {
      //this.search.archive = !this.search.archive ? 1 : 0
      e.preventDefault();


    },

    set_contentnav() {
      this.$store.commit('operatingpoint/updatesearch', this.search);
      this.$store.commit('shoppingcart/updateSearchFlag', 'directsearch');
      /*if come back from shoppingcart we are not need to show op values in overview*/
      this.$store.commit('operatingpoint/updateairflow', '')
      this.$store.commit('operatingpoint/updatepressure', '')
      this.$store.commit('operatingpoint/updateSelectedCategories', [])


      //this.$store.commit('operatingpoint/updatesearchsuggestion',this.searchsuggestion);
      /* console.log('bin im set_contentnav from search');
      console.log('set_contentnav this.selected:')
      console.log(this.selected) */
      this.$root.$refs.main.listenerchild({ nav: "3", searchflag: "directsearch" });
      //this.clearInput()
      //EventBus.$emit('loadprodlist'); //in ProductListTable
    },
    init() {
      this.from = this.parentID
    },
    /*test autosuggest:*/
    clickHandler(item) {
      //console.log('clickHandler')
      this.cbvisible = true
      // event fired when clicking on the input
    },
    focusMe(e) {
      console.log(e) // FocusEvent
    },
    fetchResults() {
      const query = this.search.keyword
      var body = []

      clearTimeout(this.timeout);
      if (query !== '') {

        this.timeout = setTimeout(() => {
          body.push({
            language_id: this.$lang().locale, //navigator.language,
            searchkeyword: this.search.keyword,
            searcharchive: this.search.archive,
          })


          const productsPromise = operatingpointApi.getFansSuggest(body)

          Promise.all([productsPromise]).then(values => {
            this.suggestions = [];
            this.selected = null;
            const products = values[0].products.filter(item=>item.flag_fan==1)
            const accessories = values[0].products.filter(item=>item.flag_fan==2)
            if(products!==null &&  products.length>0) this.suggestions.push({ name: "products", data: products });
            if(accessories!==null &&  accessories.length>0) this.suggestions.push({ name: "accessories", data: accessories });
          });
        }, this.debounceMilliseconds);
      }
    },
    filterResults(data, text, field) {
      return data
        .filter(item => {
          if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
            return item[field];
          }
        })
        .sort();
    },
    /*:renderSuggestion="renderSuggestion"
    renderSuggestion(suggestion) {
      if(suggestion.name === "products") {
        const selected_el = suggestion.item;
        return selected_el.ref_no  +' '+selected_el.type
      }
      else if (suggestion.name === "hotels") {
        const image = suggestion.item;
        console.log(image);
        return image.title
      } else {
        return suggestion.item.name;
      }
    },
    */
    getSuggestionValue(suggestion) {
      let { name, item } = suggestion;
      //return name =="products" ? item.ref_no + ' ' + item.type : (item. name == "accessories" ? item.title : item.name); //f.E. possible show fans and accessories separate
      //return name == "products" ? item.ref_no + ' ' + item.type : '';
      return item.ref_no + ' ' + item.type;
    },
    addProducttoShoppingcart: function (response) {
      var selectedProducts = []
      var user_settings = this.user_settings

      var stored_products = this.$store.state.shoppingcart.shoppingcartlist
      var index = stored_products.length - 1
      index++

        var show_price=true;
        if (!this.user.auth || this.user.countries_price == '' || (this.user.auth && this.user.countries_price != this.selectedlocale.country) ) {
          show_price=false
        }

      if (response != null) { //if(selectedProducts.length>0){
        response.forEach(function (item) {
          if (item.product_prices.length != 0 && show_price) {
            item.delivery = item.product_prices[0].delivery
            item.price = item.product_prices[0].price.toFixed(2)
            item.listprice = item.product_prices[0].price.toFixed(2)
          }
          else {
            item.delivery = 'A'
            item.price = 0
            item.listprice =0
          }

            //ToDo hier st description and image

          if (item.product_media.length != 0) {
            item.image = item.product_media.filter(item => item.media_type == 'image').map(function (image) { return image.path + image.filename })[0]
          }
          if (item.product_descriptions.length != 0) {
            item.description_short = item.product_descriptions.map(function (desc) { return desc.description_short })[0]
            item.description_long = item.product_descriptions.map(function (desc) { return desc.description_long })[0]
          }
          if (item.accessories.length != 0) {
            var childs = []
            for (var k = 0; k < item.accessories.length; k++) {

              childs.push({
                ref_no: item.accessories[k].product_child_ref_no,
                quantity: 0,
                type: item.accessories[k].type,
                description_short: item.accessories[k].description_short,
                description_long: item.accessories[k].description_long,
                wg: item.accessories[k].wg,
                items: item.accessories[k].items,
                price: show_price?item.accessories[k].price:0,
                listprice: show_price?item.accessories[k].price:0,
                image: item.accessories[k].image,

              });
            }

            if (item.flag_fan == 1) Object.assign(item, { accessories: childs, countaccessories: item.accessories.length })
            else Object.assign(item, { items: childs, countaccessories: childs.length })

          }
        })
        selectedProducts = response



        // add quantity, user_settings for each product:
        selectedProducts.forEach(function (product) {
          Object.assign(product, { quantity: 1, positiontext: '', product_source: 1, productmarker: 0 , incrementedColumn: 0 }, user_settings)
        });

        stored_products.splice(index, 0, ...selectedProducts)
        index++
/*
        // sum products with same ref_no and parent:
        let stored_products_qtysum = stored_products.reduce(function (acc, curr) {
          //let findIndex = acc.findIndex(item => (item.ref_no == curr.ref_no && item.parent_product == curr.parent_product));
          let findIndex = acc.findIndex(item => item.ref_no == curr.ref_no);
          if (findIndex === -1) {
            acc.push(curr)
          } else {
            //acc[findIndex].quantity = (curr.parent_product && parentID=='shoppingcart') || parentID!='shoppingcart' ? parseInt(acc[findIndex].quantity) +  parseInt(curr.quantity) : parseInt(curr.quantity)
            acc[findIndex].quantity = parseInt(acc[findIndex].quantity) + parseInt(curr.quantity)
          }
          return acc;
        }, [])

        //console.log('stored_products_qtysum:')
        stored_products = stored_products_qtysum */



        let i = 0
        stored_products.forEach(function (el) {
          Object.assign(el, { index: i })
          i++
        })

        console.log('storeSelectedProducts stored_products:')
        console.log(stored_products)
        this.$store.commit('shoppingcart/updateShoppingcartList', stored_products)
        this.clearInput()

      }
    },

    storeSelectedProducts: function () {
      if(this.selected==null) return
      var params = { ref_no: this.selected.ref_no, version: this.selected.version, language_id: this.$lang().locale }  //navigator.language,}
      productdataApi.getProductdata(params)
        .then(response => {
          console.log('response.data.productdata:')
          console.log(response.data.productdata)
          this.addProducttoShoppingcart(response.data.productdata)
        })
        .catch(function () {
          console.log('quickselect.getProductdata');
        });
    },

    clearInput: function () {
      this.selected = null
      this.search.keyword = ''
    },
    resetInputData: function () {
      this.selected = null
      this.search.keyword = ''
      this.search.archive = ''
    }
  },
  mounted() {
      // console.log('product search anthi')
      // activate search tab and archive search when the parameter is in url
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const searchArchiv = urlParams.get('search_archiv')
      // console.log('this.search.archive'+this.search.archive)

      if (searchArchiv && searchArchiv == '1') {
          let searchTab = document.getElementById('search-nav-tab')
          let searchTabPane = document.getElementById('search-tab-pane')
          let allTabPanes = document.querySelectorAll('.tab-pane')
          let allLinksTabs = document.querySelectorAll('.nav-tabs > .nav-item > .nav-link')
          let checkboxArchive = document.querySelectorAll('#search-tab-pane input#archive')
          let searchInputFields = document.querySelectorAll('#autosuggest__input')
          var body = [];
          this.search.archive = true;

          searchInputFields.forEach((searchInputField)=>{
              body.push({
                  searcharchive: this.search.archive,
              })
          });
          // console.log('this.search.archive inside if '+this.search.archive)

          allTabPanes.forEach((tabPane) => {
              tabPane.classList.remove('active')
          });

          allLinksTabs.forEach((linkTab) => {
              linkTab.classList.remove('active');
          })

          checkboxArchive[1].checked = true;
          // checkboxArchive[1].classList.add('aaanthi')
          searchTab.classList.add('active');
          searchTabPane.classList.add('active');
      }
  },
  created() {
    this.init()
  },
  watch: {
    parentID: function (new_value) {
      this.init()
    }
  }


}
</script>

<style>
.input-group {
  position: relative;
  display: flex;
  flex-wrap: nowrap !important;
  align-items: stretch;
  width: 95%;

}

#autosuggest > div[role="combobox"] {
      /* position: relative;*/
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      width: 100%;
      flex-shrink: 0;

    }

 #autosuggest>div[role="combobox"] > .form-control {

   padding: .5rem 1rem;
   line-height: 1.5;
 }
 #autosuggest>div[role="combobox"]>.form-control:not(textarea) {
   /*height: calc(1.5em + 1rem + 2px);*/
   height: calc(1.5em + .65rem + 2px);
 }

.labelprevent {
  pointer-events: none;
  cursor: default;
}


.input-group> div >.form-control:focus {
  border-color: #e8e8e8
}


/* #autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
} */



/*  in autosuggest.scss
.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 1001;
  width: 100%;
  border: 1px solid #e0e0e0;
   background: white;
  padding: 0px;
  max-height: 400px;
  overflow-y: scroll;
  border-radius: .375rem !important;

}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
    cursor: pointer;
    padding: 10px 15px 0px 15px;
    color: #6c757d;
    line-height: 0.3rem;
    font-size: 0.7rem;
    border-bottom: 1px solid lightgray;
}

#autosuggest ul:nth-child(1)>.autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}
*/
.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}


/*
#autosuggest.input-group {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    width: 100%;
} */
.input-group-append-search {
  margin-left: -5px;
}

.input-group-append-search {
  display: flex;
}

.input-group:not(.has-validation)>.input-group-append-search:not(:last-child)>.btn,
.input-group:not(.has-validation)>.input-group-append-search:not(:last-child)>.input-group-text,
.input-group.has-validation>.input-group-append-search:nth-last-child(n+3)>.btn,
.input-group.has-validation>.input-group-append-search:nth-last-child(n+3)>.input-group-text,
.input-group>.input-group-append-search:last-child>.btn:not(:last-child):not(.dropdown-toggle),
.input-group>.input-group-append-search:last-child>.input-group-text:not(:last-child) {
  border-top-right-radius: .375rem;
  border-bottom-right-radius: .375rem;
}

.input-group>.input-group-append-search>.btn,
.input-group>.input-group-append-search>.input-group-text,
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.w-93 {
  width: 93% !important;
}
.border_append{
  border: 1px solid #c7c7c7;
}
</style>

